import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Debug from 'debug';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ActionWithPayload } from '../actions/annualReport.actions';
import * as fromActions from '../actions/annualreport-shares.action';
import { CreateShareDto } from '../dtos/createShare.dto';
import { GetShareDto } from '../dtos/getShare.dto';
import { AumicoAnnualReportSharesService } from '../services/annual-report-shares.service';

const debug = Debug('aumico:aumico-lib-annualreport-fe:AnnualReportEffects');

@Injectable()
export class AnnualReportSharesEffects {
    constructor(private actions$: Actions, private service: AumicoAnnualReportSharesService) {}

    shareAnnualReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.shareAnnualReport.do),
            mergeMap(({ payload }: ActionWithPayload<CreateShareDto>) => {
                return this.service.shareAnnualReports$(payload).pipe(
                    map((response) => {
                        return fromActions.shareAnnualReport.success({ payload: response });
                    }),
                    catchError((error) => {
                        return of(fromActions.shareAnnualReport.failure({ payload: error }));
                    }),
                );
            }),
        ),
    );

    getCurrentActiveUserSharedAnnualReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getNewAnnualReportsSharedWithMe.do),
            mergeMap(() => {
                return this.service.getCurrentActiveUserSharedAnnualReports$().pipe(
                    map((response: GetShareDto[]) => {
                        return fromActions.getNewAnnualReportsSharedWithMe.success({ payload: response });
                    }),
                    catchError((error) => {
                        return of(fromActions.getNewAnnualReportsSharedWithMe.failure({ payload: error }));
                    }),
                );
            }),
        ),
    );

    declineSharedAnnualReport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.declineSharedAnnualReport.do),
            mergeMap((action: ActionWithPayload<string>) => {
                return this.service.declineSharedAnnualReport$(action.payload).pipe(
                    map(() => {
                        return fromActions.declineSharedAnnualReport.success();
                    }),
                    catchError((error) => {
                        return of(fromActions.declineSharedAnnualReport.failure({ payload: error }));
                    }),
                );
            }),
        ),
    );
    acceptSharedAnnualReport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.acceptSharedAnnualReport.do),
            mergeMap((action: ActionWithPayload<string>) => {
                return this.service.acceptSharedAnnualReport$(action.payload).pipe(
                    map(() => {
                        return fromActions.acceptSharedAnnualReport.success();
                    }),
                    catchError((error) => {
                        return of(fromActions.acceptSharedAnnualReport.failure({ payload: error }));
                    }),
                );
            }),
        ),
    );

    getShareInformation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getShareInformation.do),
            mergeMap(({ payload }: ActionWithPayload<string>) => {
                return this.service.getShareInformation$(payload).pipe(
                    map((response) => {
                        return fromActions.getShareInformation.success({
                            payload: {
                                shareInformation: response,
                                annualReportMetaInformationId: payload,
                            },
                        });
                    }),
                    catchError((error) => {
                        return of(fromActions.getShareInformation.failure({ payload: error }));
                    }),
                );
            }),
        ),
    );
}
